<template>
  <Modal ref="modal">
    <h2>Retirer des unités de {{ product.name }}</h2>
    <div class="form-inline-group">
      <label class="form-label">
        Nombre d'unités à retirer
      </label>
      <input
        v-model="nbUnits"
        type="number"
        class="form-control"
        style="margin-left: 5px;">
    </div>

    <div class="form-group">
      <StorageSelect v-model="srcStorageId" />
    </div>

    <template #buttons>
      <button
        class="btn-secondary"
        :disabled="submitting"
        @click="hide">
        Annuler
      </button>
      
      <button
        class="btn-primary"
        :class="{ 'loading': submitting }"
        :disabled="submitting"
        style="margin-left: 5px;"
        @click="submit">
        Valider
      </button>
    </template>
  </Modal>
</template>

<script>

import Modal from "@/components/modals/Modal.vue";
import StorageSelect from "@/components/selects/StorageSelect.vue";
import { useStoragesStore } from "@/stores/storages";

export default {
  name: "RemoveUnitsOfProductFromStockModal",
  components: {
    Modal,
    StorageSelect,
  },
  props: {
    modelValue: {
      type: Object,
      required: true,
    },
    srcStorage: {
      type: Object,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      nbUnits: 0,
      selectedStorageId: null,
      submitting: false,
      storagesStore: useStoragesStore(),
    };
  },
  computed: {
    product: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit(
          "update:modelValue",
          value,
        );
      },
    },
    storages() {
      return this.storagesStore.getStorages;
    },
    defaultStorage() {
      if (!this.storages) return null;
      return this.storages.find(storage => storage.default);
    },
    srcStorageId: {
      get() {
        if (this.selectedStorageId) {
          return this.selectedStorageId;
        } else if (this.srcStorage) {
          return this.srcStorage.id;
        } else if (this.defaultStorage) {
          return this.defaultStorage.id;
        } else {
          return null;
        }
      },
      set(value) {
        this.selectedStorageId = value;
      },
    },
  },
  methods: {
    show() {
      this.$refs.modal.show();
    },
    hide() {
      this.$refs.modal.hide();
    },
    submit() {
      this.submitting = true;
      this.validationError = null;
      this.$services.storage.removeProductUnits(this.srcStorageId, this.product.id, this.nbUnits)
        .then(() => {
          this.hide();
        }).finally(() => {
          this.submitting = false;
        });
    },
  },
};
</script>

<style lang="scss" scroped>

   
</style>